import { useEffect } from 'react';

import { ENV } from '../config/env';

const loadInsightTag = (partnerId: string): (() => void) => {
  const partnerScript = document.createElement('script');
  partnerScript.type = 'text/javascript';
  partnerScript.text = `
    _linkedin_partner_id = "${partnerId}";
    window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
    window._linkedin_data_partner_ids.push(_linkedin_partner_id);
  `;
  document.body.appendChild(partnerScript);

  const loaderScript = document.createElement('script');
  loaderScript.type = 'text/javascript';
  loaderScript.text = `
    (function(l) {
      if (!l){window.lintrk = function(a,b){window.lintrk.q.push([a,b])};
      window.lintrk.q=[]}
      var s = document.getElementsByTagName("script")[0];
      var b = document.createElement("script");
      b.type = "text/javascript";b.async = true;
      b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
      s.parentNode.insertBefore(b, s);
    })(window.lintrk);
  `;
  document.body.appendChild(loaderScript);

  return () => {
    partnerScript.remove();
    loaderScript.remove();
  };
};

export const LinkedInInsightTag = () => {
  const partnerId = ENV.LINKEDIN_PARTNER_ID?.trim();
  const isProduction = ENV.APP_ENV === 'prd';

  useEffect(() => {
    if (!isProduction || !partnerId) {
      return;
    }

    return loadInsightTag(partnerId);
  }, [isProduction, partnerId]);

  if (!isProduction || !partnerId) {
    return null;
  }

  return (
    <img
      height="1"
      width="1"
      style={{ display: 'none' }}
      alt=""
      src={`https://px.ads.linkedin.com/collect/?pid=${partnerId}&fmt=gif`}
    />
  );
};
